import { useNavigate, useParams } from 'react-router-dom';
import { Button, Panel } from 'nhsuk-react-components';
import useFetchTeamMembers from 'queries/fetch/fetchTeamMembers.ts';
import useFetchTeamDetails from 'queries/fetch/fetchTeamDetails.ts';
import ProgressIndicator from 'components/ProgressIndicator';
import { IManageUserPageParams } from 'utils/parameterUtils.ts';
import { getUserDisplayName } from 'utils/userUtils.ts';

function EditUserPermissionsConfirmationPage() {
  const { teamId, userId } = useParams() as IManageUserPageParams;
  const navigate = useNavigate();
  const teamMembers = useFetchTeamMembers();
  const teamDetails = useFetchTeamDetails({ teamId });
  const currentUser = teamMembers.data?.[teamId].read.find((t) => t.sub === userId);

  if (!teamMembers.data || !currentUser || teamDetails.isFetching) {
    return <ProgressIndicator />;
  }

  const teamName = teamDetails.data?.team.TEAM_NAME ?? teamId;

  const handleContinue = () => {
    navigate(`/admin/${teamId}/manage-user-details/user/${userId}`);
  };

  return (
    <>
      <Panel>
        <Panel.Title>
          {getUserDisplayName(currentUser)}
          &apos;s permissions for &apos;
          {teamName}
          &apos; have been updated
        </Panel.Title>

        <div>The next screen will show the user&apos;s details.</div>

        <div className="nhsuk-u-margin-top-4">If you would like to change the user permissions click the &quot;Edit permissions&quot; button.</div>
      </Panel>
      <Button onClick={handleContinue}>Continue</Button>
    </>
  );
}

export default EditUserPermissionsConfirmationPage;
